import { render, staticRenderFns } from "./TTPhoneInput.vue?vue&type=template&id=64545e7a"
import script from "./TTPhoneInput.vue?vue&type=script&lang=js"
export * from "./TTPhoneInput.vue?vue&type=script&lang=js"
import style0 from "./TTPhoneInput.vue?vue&type=style&index=0&id=64545e7a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports